import { render, staticRenderFns } from "./left-top.vue?vue&type=template&id=1b9f3e8a&scoped=true&"
import script from "./left-top.vue?vue&type=script&lang=js&"
export * from "./left-top.vue?vue&type=script&lang=js&"
import style0 from "./left-top.vue?vue&type=style&index=0&id=1b9f3e8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9f3e8a",
  null
  
)

export default component.exports